import { render } from "./description.vue?vue&type=template&id=830c78ee"
import script from "./description.vue?vue&type=script&lang=ts"
export * from "./description.vue?vue&type=script&lang=ts"
script.render = render

export default script